<template>
  <div class="share-box">
    <input
      ref="text"
      type="text"
      :value="url"
      readonly
    />
    <button @click="copy">
      <icon
        name="chain-link"
        variant="white"
      />
    </button>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    url: {
      type: String,
    },
  },
  methods: {
    copy() {
      const textInput = this.$refs.text;
      textInput.select();
      textInput.setSelectionRange(0, 99999); // for mobile devices
      document.execCommand('copy');

      this.$notify({
        group: 'notifications',
        text: 'Share URL copied!',
        type: 'success',
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.share-box {
  position: relative;

  input {
    background: #e9edf1;
    border-radius: 4px;
    box-sizing: border-box;
    color: #999999;
    font-size: rem-calc(13);
    font-weight: $semi-bold;
    height: 44px;
    width: 100%;
  }

  button {
    background: #00d8f8;
    border-radius: 4px;
    bottom: 0;
    padding: 15px;
    position: absolute;
    right: 0;
    top: 0;

    img {
      height: 14px;
      width: 14px;
    }
  }
}
</style>
